module.exports = __webpack_public_path__ + "static/media/star_B605D5.4392e0eb.svg";